import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscribedMap } from "../../../Pages/SubscribedMap/ISubscribed";

export const AddSubscribedMapSlice = createSlice({
  name: "AddSubscribedMapSlice",
  initialState: {} as IReduxState<ISubscribedMap>,
  reducers: {
    addSubscribedMap: (state, _: PayloadAction<ISubscribedMap>) => {
      state.isLoading = true;
    },
    successaddSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureaddSubscribedMap: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearAddSubscribedMapResponse: (state) => {
      state.data = {};
    },
  },
});

export const {
  addSubscribedMap,
  failureaddSubscribedMap,
  successaddSubscribedMap,
  clearAddSubscribedMapResponse,
} = AddSubscribedMapSlice.actions;

export default AddSubscribedMapSlice.reducer;
